import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  FlutterIcon,
  HealthcareIcon,
  ReactIcon,
} from "../../../app-constants";

const StackItem = [
  {
    icon: AndroidIcon,
    title: "Android Application Development",
    description: `Our transformative Android app development company uses Kotlin and Java to create responsive, feature-rich apps. From ready-to-roll white-label apps to end-to-end customized solutions, our mobile app development prowess helps you get business-specific, performant products. Zero trust security, user-friendly interface, compatible interface, and room for scalability are our minimum bar every time we build an app. Take advantage of our reliable app development in Austin to reach the user quickly with the best experience.`,
  },
  {
    icon: IphoneIcon,
    title: "iOS Application Development",
    description: `Accelerate your business with custom iOS app development services leveraging Swift, Objective-C, and Xcode. Built the best user experiences with ARKit, Core ML, and SwiftUI to offer useful, in-demand functionalities and easy-to-navigate UI/UX. Expand monetization opportunities through in-app purchases, subscriptions, and personalized user interactions to maximize revenue and user retention.`,
  },
  {
    icon: GameIcon,
    title: "Game Application Development",
    description:
      "Transform gaming experiences with powerful engines like Unity and Unreal Engine. We specialize in immersive game app development services using HTML5 frameworks for engaging entertainment across platforms. Unlock and cash new revenue streams through in-app purchases and advertisements. With proven application development expertise, we leverage user analytics for continuous game optimization and better experiences – that eventually leads to game app success.",
  },
  {
    icon: FlutterIcon,
    title: "Flutter Application Development",
    description:
      "Leverage Flutter's versatility for cross-platform excellence with TekRevol – a value-driven app development company. Our Flutter application development services deliver high-definition interfaces, platform-specific functionalities, and smooth animations to fulfil modern business needs for responsive and visually appealing applications. Our team of expert mobile app developers in Austin excels at single codebase built for various platforms to maintain best experience across devices and drive maximum returns.",
  },
  {
    icon: ReactIcon,
    title: "React Native Application Development",
    description:
      "We thrive as a reliable React Native app development company with useful-only resources and focalized processes for robust Android and iOS apps. Our expertise in Redux, API integrations, and UI/UX design ensures optimal performance and user engagement. Startups benefit from rapid MVP development, scaleups gain scalable solutions, and enterprises achieve cross-platform compatibility for wider market reach.",
  },
  {
    icon: HealthcareIcon,
    title: "Progressive Web Application Development",
    description:
      "Our progressive web app development services help businesses create high-performing web-based solutions with an offline-first architecture, seamless service worker integration, and responsive design. Using push notifications, an app shell model, and fast load times, we deliver native-like experiences that engage users across devices and ensure an installable and highly accessible app performance.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>Custom Mobile App Development Services in Austin</h2>
            <p className="impro_para">
              Decode, Disrupt, & Dominate. TekRevol is your reliable app
              development company in Austin unifying the user engagement gap,
              business expansion goals, and technology required with
              purpose-driven application development in the USA leveraging a
              team of the most sought-after app developers in Austin. Let’s look
              into our core mobile app development services in Austin businesses
              trust us for.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
